import { useEffect } from 'react'
import { useAuth } from '../context/useAuth'
import { useWorkspace } from '../context/useWorkspace'
import { startLineLearningSignalFlush } from '../services/lineLearningSignalFlush'
import { useLineSignalPause } from '../services/lineSignalPause'
import { getLineWorkspacePolicy } from '../services/lineWorkspacePolicy'
import { setLineWorkspaceSignalCaptureState } from '../services/lineLearningSignals'

/** Keeps learning-signal delivery outside Line interactions, so no user action can trigger a write. */
export const LineLearningSignalFlushBridge = () => {
  const { currentUser } = useAuth()
  const { activeWorkspaceId } = useWorkspace()
  const paused = useLineSignalPause(activeWorkspaceId)

  useEffect(() => {
    if (!activeWorkspaceId) return
    void getLineWorkspacePolicy(activeWorkspaceId).then((policy) => setLineWorkspaceSignalCaptureState(activeWorkspaceId, { paused, enabled: policy.learning.signalCaptureEnabled, killSwitch: policy.learning.globalKillSwitch }))
  }, [activeWorkspaceId, paused])

  useEffect(() => {
    if (!currentUser?.uid || !activeWorkspaceId || paused) return undefined
    return startLineLearningSignalFlush(activeWorkspaceId)
  }, [activeWorkspaceId, currentUser?.uid, paused])

  return null
}
